import { useState } from "react";
import { Edit } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import type { User } from "@/types/user";
import { UserForm } from "./UserForm";

interface EditUserDialogProps {
  user: User;
}

export function EditUserDialog({ user }: EditUserDialogProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center justify-center text-gray-600 hover:text-blue-600 transition-colors"
          aria-label="تعديل المستخدم"
          title="تعديل المستخدم"
        >
          <Edit className={cn("w-4", "h-4")} />
        </button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader className="text-right">
          <DialogTitle>تعديل المستخدم</DialogTitle>
          <DialogDescription className="sr-only">
            تعديل بيانات المستخدم
          </DialogDescription>
        </DialogHeader>
        <UserForm user={user} setOpen={setOpen} />
      </DialogContent>
    </Dialog>
  );
}
